import React__default, { useEffect } from 'react';
import '../../core/enums/GameSpecificTypes.js';
import '../../core/enums/MaxPayoutDataTypes.js';
import '../../core/enums/Chat.js';
import '../../core/enums/GameModes.js';
import '../../core/enums/IconTypes.js';
import '../../core/enums/BetStatus.js';
import '../../core/enums/PopupTypes.js';
import '../../core/enums/ApiVersion.js';
import '../../core/enums/RoundStatus.js';
import '../../core/enums/FreeBetsStatus.js';
import '../../core/enums/SocketEvents.js';
import '../../core/enums/TranslationKeys.js';
import '../../core/enums/TimeoutMaxValue.js';
import '../../core/enums/ApiServiceTypes.js';
import '../../core/enums/EnvironmentTypes.js';
import '../../core/enums/DefaultQueryValues.js';
import '../../core/enums/FreeBetWinningType.js';
import '../../core/enums/DefaultQueryParams.js';
import '../../core/enums/BetHistoryFilterTypes.js';
import '../../core/enums/GameThemeTypes.js';
import '../../core/enums/RequestStatus.js';
import '../../core/enums/FetchDefaultPaths.js';
import '../../core/enums/ResponseCodes.js';
import { N as applicationStore, i as iframeService, w as platformMessageStore } from '../../../loadingStore-157b56fd.js';
import '../../core/store/chatStore.js';
import '../../core/store/wageringStore.js';
import '../../core/store/roundInfoStore.js';
import '../../core/store/userCountStore.js';
import '../../core/store/gameResultStore.js';
import '../../core/store/resultHashStore.js';
import '../../core/store/userWinBetsStore.js';
import '../../core/store/notificationStore.js';
import '../../core/store/selectedResultInfoStore.js';
import '../../core/services/liveConnection/types.js';
import 'axios';
import '../../core/services/sound/types.js';
import '../../core/services/sound/SoundService.js';
import '../../core/services/sound/defaultSounds.js';
import '../../core/services/api/types.js';
import '../../core/services/ApiServices.js';
import '../../../momentFormat-14fce7b4.js';
import '../../core/polyfill.js';
import { observer } from 'mobx-react-lite';
import '../../../tslib.es6-14c74580.js';
import 'mobx';
import '@microsoft/signalr';
import '../../core/classes/httpResponse/index.js';
import '../../core/helpers/environmentBuilder.js';
import '../../core/enums/BogLineGameConfig.js';
import '../../core/helpers/parseQuery.js';
import '../../core/services/api/BaseApiService.js';
import '../../core/enums/StatisticsSortingTypes.js';
import '../../../table-line/t_types/enums/BetResponseCode.js';
import '../../../table-line/t_types/enums/BetErrorMessages.js';
import '../../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../../table-line/t_types/enums/FreeChipTypes.js';
import '../../../table-line/t_types/enums/PopupTypes.js';
import '../../core/helpers/formatDate.js';
import '../../core/helpers/updateHalfBets.js';
import '../../core/enums/bogGameNames.js';
import 'howler';
import '../../../_commonjsHelpers-1a7a244d.js';

var PlatformMessagesWrapper = observer(function (_a) {
    var children = _a.children, _b = _a.additionalMessagesParams, additionalMessagesParams = _b === void 0 ? [] : _b, isBetShop = _a.isBetShop, autoPlayOnAndOffState = _a.autoPlayOnAndOffState;
    var isAuthDataReceived = applicationStore.isAuthDataReceived;
    useEffect(function () {
        if (!isBetShop) {
            iframeService.setPostMessageListener(additionalMessagesParams);
            iframeService.sendGetAuthInfo();
        }
    }, [isBetShop]);
    /// AUTOPLAY STATE CHECKER
    useEffect(function () {
        if (!autoPlayOnAndOffState) {
            iframeService.checkAndSendAutoPlayState(autoPlayOnAndOffState);
        }
        platformMessageStore.setIsAutoPlayOnInGame(autoPlayOnAndOffState);
    }, [autoPlayOnAndOffState]);
    return isBetShop || isAuthDataReceived ? children : React__default.createElement(React__default.Fragment, null);
});

export { PlatformMessagesWrapper };
